import axios from 'axios';
import qs from 'qs';

const NX_BARCODE_GUN_APP_V2_API_URL = process.env['NX_BARCODE_GUN_APP_V2_API_URL'] ?? '';
export const barcodeBackendAxios = axios.create({
	baseURL: `${NX_BARCODE_GUN_APP_V2_API_URL}`,
	transformResponse: [
		(data) => {
			try {
				// 서버로부터 받은 응답을 파싱
				const parsedData = JSON.parse(data);

				// 모든 값이 null인 속성을 undefined로 변환하는 재귀 함수
				const convertNullToUndefined = (obj: any): any => {
					if (Array.isArray(obj)) {
						return obj.map(convertNullToUndefined);
					} else if (obj !== null && typeof obj === 'object') {
						return Object.fromEntries(
							Object.entries(obj).map(([key, value]) => [
								key,
								value === null ? undefined : convertNullToUndefined(value),
							])
						);
					}
					return obj;
				};

				return convertNullToUndefined(parsedData);
			} catch {
				return data;
			}
		},
	],
});

type ResponseEntityType<T> = {
	headers: {
		[key: string]: string;
	};
	body: T;
	statusCode: 'OK' | string;
	statusCodeValue: number;
};

type ErrorData = {
	code: string;
	message: string;
};

barcodeBackendAxios.interceptors.response.use(
	(response) => {
		if ((response.data as ResponseEntityType<any>).statusCode === 'OK')
			response.data = response.data.body;

		return response;
	},
	(error) => {
		if (error.response.data) return Promise.reject(error.response.data as ErrorData);
		// 401 처리
		else if (error.code === 'ERR_BAD_REQUEST')
			return Promise.reject({
				code: 'DEV_ERROR',
				message: '서버와의 연결이 끊어졌습니다.',
			});
		// 네트워크 에러 처리
		else if (error.code === 'ERR_NETWORK')
			return Promise.reject({
				code: 'NETWORK',
				message: '네트워크 에러입니다.',
			});
		else
			return Promise.reject({
				code: error.code,
				message: error.message,
			});
	}
);

barcodeBackendAxios.interceptors.request.use((config) => {
	if (!config.headers) return config;

	config.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });

	const accessToken = localStorage.getItem('accessToken');
	const refreshToken = localStorage.getItem('refreshToken');
	const enterpriseHash = localStorage.getItem('enterpriseHash');

	if (accessToken) config.headers['Authorization'] = `Bearer ${accessToken}`;
	if (refreshToken) config.headers['refreshToken'] = `Bearer ${refreshToken}`;
	config.headers['Enterprise-Hash'] = enterpriseHash || '';

	return config;
});
